import { apiBackends } from "@/apiBackends.ts";
import { WSelect } from "@/components/forms/WSelect.tsx";
import { apiPrefixAtom, canSelectApiPrefix } from "@/modules/api/createApiClient.ts";
import { useAtom } from "jotai/react";

function ApiPrefixSelect() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [prefix, setPrefix] = useAtom(apiPrefixAtom);

    return (
        <WSelect
            aria-label="API provider"
            placeholder="API prefix"
            valueKey={prefix}
            items={apiBackends}
            getKey={(item) => item.apiPrefix}
            getTextValue={(item) => `${item.label} (${item.apiHost})`}
            searchItems
            onChange={(item) => {
                setPrefix(item.apiPrefix);
            }}
        >
            {(item) => (
                <span className="flex gap-0.5em">
                    <span>{item.label}</span>
                    <span className="text-muted">({item.apiHost})</span>
                </span>
            )}
        </WSelect>
    );
}

export default canSelectApiPrefix ? ApiPrefixSelect : () => null;
